import { updateComponent } from '../../../../app/package-designer/store/component.actions';

xplenty.directive('rankEditor', [
  '$timeout',
  function ($timeout) {
    return {
      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('./rank-editor.html'),

      replace: true,

      link(scope) {
        $timeout(function () {
          if (scope.componentForm.$invalid && scope.componentForm.field_alias) {
            scope.componentForm.field_alias.$setTouched();
            scope.componentForm.field_alias.$setDirty();
          }
        });
      },

      controller: [
        '$scope',
        'ngrxStoreService',

        function ($scope, ngrxStoreService) {
          $scope.onValidityChange(false);
          $scope.onValidityChange(false);
          $scope.sortCollectionValid = false;

          $scope.onDataOrderChange = ({ data_order }) => {
            const component = { data_order };

            if (component.data_order === 'no_sort') {
              component.fields = [];
            }
            ngrxStoreService.dispatch(updateComponent({ component }));
          };

          $scope.onDenseChange = ({ dense }) => {
            ngrxStoreService.dispatch(updateComponent({ component: { dense } }));
          };

          $scope.onFieldAliasChange = ({ field_alias }) => {
            ngrxStoreService.dispatch(updateComponent({ component: { field_alias } }));
          };

          $scope.onSortCollectionValidityChange = (value) => {
            $scope.sortCollectionValid = value;
          };

          $scope.onRecordsChange = (value) => {
            $scope.component.fields = value;
          };

          $scope.$watch(
            '[sortCollectionValid, component.data_order, componentForm.field_alias.$valid]',
            function () {
              const valid =
                ($scope.component.data_order === 'no_sort' || $scope.sortCollectionValid) &&
                $scope.componentForm.field_alias.$valid;

              $scope.onValidityChange(valid);
            },
            true,
          );
        },
      ],
    };
  },
]);
